import { Sidebar } from 'flowbite-react';
import { HomeIcon, ServiceIcon, PersonalCardIcon, CubeBoxIcon, EnvelopeIcon, CloseIcon } from '../icons/icons';
import { flowbiteCustomSidebarThemeConfig } from '../../shared/flowbiteThemeConfig';
import { Link, useLocation } from 'react-router-dom';
import { useContext } from 'react';
import { IAppContextState, AppContext } from '../../App';

function SidebarComponent() {
  const location = useLocation();
  const { isCollapsedSidebarState } = useContext<IAppContextState | any>(AppContext);
  const [isCollapsedSidebar, setIsCollapsedSidebar] = isCollapsedSidebarState;

  const changeState = () => {
    if (window.innerWidth < 768) {
      setIsCollapsedSidebar(true);
    }
  };

  return (
    <>
      <Sidebar theme={flowbiteCustomSidebarThemeConfig} className={`${isCollapsedSidebar ? 'left-[-16rem]' : 'left-0'} md:fixed absolute top-0 transition-all h-[100vh] z-10`}>
        <Sidebar.Items className='w-full'>
          <Sidebar.ItemGroup>
            <Link to='/' title='Homepage' relative='path' className='w-full' onClick={changeState}>
              <Sidebar.Item icon={HomeIcon} active={location.pathname === '/'}>
                Home
              </Sidebar.Item>
            </Link>
            <Link to='/about-me' title='About me' relative='path' className='w-full' onClick={changeState}>
              <Sidebar.Item icon={PersonalCardIcon} active={location.pathname === '/about-me'}>
                About me
              </Sidebar.Item>
            </Link>
            <Link to='/my-services' title='My services' relative='path' className='w-full' onClick={changeState}>
              <Sidebar.Item icon={ServiceIcon} active={location.pathname === '/my-services'}>
                Services
              </Sidebar.Item>
            </Link>
            <Link to='/my-projects' title='My projects' relative='path' className='w-full' onClick={changeState}>
              <Sidebar.Item icon={CubeBoxIcon} active={location.pathname === '/my-projects'}>
                Projects
              </Sidebar.Item>
            </Link>
            <Link to='/contact' title='Contact' relative='path' className='w-full' onClick={changeState}>
              <Sidebar.Item icon={EnvelopeIcon} active={location.pathname === '/contact'}>
                Contact
              </Sidebar.Item>
            </Link>
          </Sidebar.ItemGroup>
        </Sidebar.Items>
        <div className='md:hidden block'>
          <button
            className='absolute top-4 right-4 w-9 h-9 bg-gray-800 hover:bg-gray-700 rounded-full flex justify-center items-center text-gray-400'
            onClick={() => setIsCollapsedSidebar(!isCollapsedSidebar)}>
            <CloseIcon />
          </button>
        </div>
      </Sidebar>
    </>
  );
}

export default SidebarComponent;
